import { SVGElementProps } from "../types/common";

export default function TelemedicineOutlined(props: SVGElementProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 16 16"
      fill="none"
      color="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_285_3274)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.338 12H12C13.1046 12 14 11.1046 14 10V4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V10C2 11.1046 2.89543 12 4 12H5.338V13.6286C5.338 13.7711 5.41969 13.901 5.54814 13.9627C5.67658 14.0245 5.82904 14.0071 5.94033 13.9181L8.338 12ZM10.5 6.66675C10.5 6.39061 10.2761 6.16675 10 6.16675H9V5.16675C9 4.89061 8.77614 4.66675 8.5 4.66675H7.5C7.22386 4.66675 7 4.89061 7 5.16675V6.16675H6C5.72386 6.16675 5.5 6.39061 5.5 6.66675V7.66675C5.5 7.94289 5.72386 8.16675 6 8.16675H7V9.16675C7 9.44289 7.22386 9.66675 7.5 9.66675H8.5C8.77614 9.66675 9 9.44289 9 9.16675V8.16675H10C10.2761 8.16675 10.5 7.94289 10.5 7.66675V6.66675Z"
          stroke="currentColor"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_285_3274">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
